export const pagePaddingInline = "clamp(1em, 10vw, 10em)";
